"use strict";

exports.__esModule = true;
exports.default = compact;
var _filter = _interopRequireDefault(require("./filter.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Trim out all falsy values from an array.
function compact(array) {
  return (0, _filter.default)(array, Boolean);
}